import React from "react";
import _ from "lodash";
import { Box, Typography } from "@mui/material";
import OrderItem from "../../OrderItem/OrderItem.view";
type OrderCartProps = {
  commande: any;
  deleteOption?: boolean;
  styles: any;
  title?: string;
  isPastOrder?: boolean;
};

const OrderCart: React.FC<OrderCartProps> = ({
  commande,
  deleteOption = false,
  styles,
  title = "Panier",
  isPastOrder

}) => {
  const keys = _.keys(commande || {});

  return (
    <>
      <Box sx={styles.title}>
        <Typography variant="h5" sx={styles.capitalize}>
          {title}
        </Typography>
      </Box>
      <>
        {keys.map((key) => {
          const item = commande[key];

          return (
            <OrderItem
              key={key}
              cartItem={item}
              cartItemKey={key}
              deleteOption={deleteOption}
              isPastOrder={isPastOrder}
            />
          );
        })}
      </>
    </>
  );
};

export default OrderCart;